import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FilterListIcon from "@mui/icons-material/FilterList";
import { OrderListTemplate } from "./OrderListTemplate";

interface OrderListHeaderProps {
  isFilterActive: boolean;
  onFilterToggle: () => void;
}

/** The order list's column headings, with the filter icon that toggles the filter panel (a dot means a filter is applied). */
export const OrderListHeader = (props: OrderListHeaderProps) => {
  const { isFilterActive, onFilterToggle } = props;

  return (
    <OrderListTemplate
      sx={{
        pb: 1.5,
      }}
    >
      <IconButton
        aria-label="Filter orders"
        onClick={onFilterToggle}
        size="small"
        sx={{
          gridArea: "expand",
          my: -0.5,
        }}
      >
        <Badge
          color="primary"
          invisible={!isFilterActive}
          variant="dot"
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>
      <Typography
        noWrap
        sx={{ gridArea: "orderNumber" }}
        variant="subtitle2"
      >
        ORDER
      </Typography>
      <Typography
        noWrap
        sx={{ gridArea: "customer" }}
        variant="subtitle2"
      >
        CUSTOMER
      </Typography>
      <Typography
        noWrap
        sx={{ gridArea: "source" }}
        variant="subtitle2"
      >
        ORIGIN
      </Typography>
      <Typography
        noWrap
        sx={{ gridArea: "status" }}
        variant="subtitle2"
      >
        STATUS
      </Typography>
      <Typography
        noWrap
        sx={{ gridArea: "orderDate" }}
        variant="subtitle2"
      >
        ORDER DATE
      </Typography>
      <Typography
        noWrap
        sx={{ gridArea: "lastSynced" }}
        variant="subtitle2"
      >
        LAST SYNCED
      </Typography>
    </OrderListTemplate>
  );
};
